// extracted by mini-css-extract-plugin
export default {"root":"IconTv_root__9vEez"};